import { useContext } from "react";
import translate from "../locales";
import clsx from "clsx";

import { ExercisePage } from "../components/exercise-page";
import { Question } from "../components/form/question";
import { InputGroup } from "../components/form/input-group";
import { TextInput } from "../components/form/text-input";
import { TextLabel } from "../components/form/text-label";

import { ClassroomContext } from "../components/classroom.context";

export function ExercisePagePast1({ onPrevious, onNext }) {
  const { requireFields } = useContext(ClassroomContext);

  return (
    <ExercisePage
      title="exercise.past_1.title"
      description="exercise.past_1.description"
      labelPrevious="exercise.past_1.button-previous"
      labelNext="exercise.past_1.button-next"
      showSources
      onPrevious={onPrevious}
      onNext={onNext}
      buttonNextDisabled={
        !requireFields(["disadvantage", "reason_disadvantage", "demand"])
      }
    >
      <title>{translate("exercise.past_1.page-title")}</title>
      <div className="exercise-card">
        <Question
          question="exercise.past_1.question_1.question"
          description="exercise.past_1.question_1.description"
        >
          <div className={clsx("input-group_background")}>
            <InputGroup>
              <TextLabel
                for="disadvantage"
                label="exercise.past_1.question_1.disadvantage-label-before"
              />
              <TextInput
                id="disadvantage"
                placeholder="exercise.past_1.question_1.disadvantage-placeholder"
                maxLength={20}
              />
              <TextLabel
                for="disadvantage"
                label="exercise.past_1.question_1.disadvantage-label-after"
              />
            </InputGroup>
            <InputGroup>
              <TextLabel
                for="reason_disadvantage"
                label="exercise.past_1.question_1.reason_disadvantage-label-before"
              />
              <TextInput
                id="reason_disadvantage"
                placeholder="exercise.past_1.question_1.reason_disadvantage-placeholder"
                maxLength={45}
              />
              <TextLabel
                for="reason_disadvantage"
                label="exercise.past_1.question_1.reason_disadvantage-label-after"
              />
            </InputGroup>
            <InputGroup>
              <TextLabel
                for="demand"
                label="exercise.past_1.question_1.demand-label-before"
              />
              <TextInput
                id="demand"
                placeholder="exercise.past_1.question_1.demand-placeholder"
                maxLength={30}
              />
              <TextLabel
                for="demand"
                label="exercise.past_1.question_1.demand-label-after"
              />
            </InputGroup>
          </div>
        </Question>
      </div>
    </ExercisePage>
  );
}
